<div class="case-type-selection__empty" *ngIf="noCaseTypes">
  {{ 'info.no_case_types' | translate }}
</div>

<div class="list-wrapper" *ngIf="!noCaseTypes">
  <div class="case-type-selection__list">
    <button
      *ngFor="let ct of items"
      type="button"
      class="case-type-selection__item"
      [class.case-type-selection__item--selected]="ct.id === selectedCaseTypeId"
      matRipple
      (click)="caseTypeSelected.emit(ct)"
    >
      {{ ct.name }}
    </button>
  </div>
</div>
